<template>
  <v-row justify="center">
    <v-dialog v-model="active" persistent scrollable max-width="500">
      <ValidationObserver ref="obs">
        <v-card>
          <v-progress-linear v-if="isLoading" indeterminate color="primary" rounded height="6"></v-progress-linear>

          <v-card-title class="pa-0 shadow-1">
            <v-card-title class="font-weight-medium primary--text">
              Informe personalizado
            </v-card-title>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text style="max-height: 350px">
              <v-form>
                <v-row dense justify="center">
                  <v-col cols="12">
                    <v-menu
                      ref="dateRangeMenu"
                      v-model="dateRangeMenu"
                      :close-on-content-click="false"
                      :return-value.sync="dates"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dates"
                          required
                          filled
                          rounded
                          class="rounded-small"
                          label="Rango de fecha"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="es-us"
                        v-model="dates"
                        :max="!['appointments'].includes(module) ? TODAY_DATE : null"
                        range
                        scrollable
                        no-title
                      >
                        <v-spacer></v-spacer>
                        <v-hover v-slot:default="{ hover }">
                          <v-btn
                            text
                            rounded
                            class="mr-1"
                            :color="hover ? 'error' : 'grey'"
                            @click="dateRangeMenu = false"
                            >Cancelar</v-btn
                          >
                        </v-hover>

                        <v-hover v-slot:default="{ hover }">
                          <v-btn
                            rounded
                            :loading="isLoading"
                            :disabled="isLoading"
                            color="success"
                            :class="hover ? 'shadow-2' : 'shadow-4'"
                            class="px-8"
                            @click="$refs.dateRangeMenu.save(dates), !module.includes('agents') && getExtensionDate()"
                            >ok</v-btn
                          >
                        </v-hover>
                      </v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" v-if="['queue'].includes(module)">
                    <v-switch
                      class="mt-0"
                      v-model="searchByHour"
                      label="Búsqueda por hora específica"
                      hide-details
                    ></v-switch>
                  </v-col>

                  <v-slide-y-transition>
                    <v-col cols="12" v-if="searchByHour">
                      <v-menu
                        ref="menuHour"
                        v-model="hour"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="time"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="time"
                            label="Seleccionar hora"
                            required
                            filled
                            rounded
                            class="rounded-small"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="hour"
                          v-model="time"
                          full-width
                          :allowed-minutes="(m) => m % 60 === 0"
                          @click:minute="$refs.menuHour.save(time)"
                        ></v-time-picker>
                      </v-menu>
                    </v-col>
                  </v-slide-y-transition>

                  <v-col cols="12" v-if="module === 'agentsQueue'">
                    <ValidationProvider rules="required" name="Colas" v-slot="{ errors }" tag="div">
                      <v-select
                        v-model="queue"
                        :disabled="isLoading || CurrentRole === 10"
                        :items="queues || AllQueues"
                        :error-messages="errors"
                        :item-value="queues ? 'item' : 'qname'"
                        :item-text="CurrentRole === 10 ? 'number' : 'item'"
                        class="rounded-small"
                        label="Colas"
                        prepend-inner-icon="mdi-database"
                        color="info"
                        multiple
                        required
                        filled
                        rounded
                        chips
                        deletable-chips
                        dense
                      >
                        <template slot="item" slot-scope="data">
                          <template v-if="!queues"> {{ data.item.name }} ({{ data.item.qname || "" }}) </template>
                          <template v-else>{{ data.item }}</template>
                        </template>
                      </v-select>
                    </ValidationProvider>
                  </v-col>

                  <!-- <v-col>
                                        <a
                                            @click="filters = !filters"
                                            class="info--text"
                                        >
                                            {{
                                                filters
                                                    ? "Menos filtros..."
                                                    : "Más filtros..."
                                            }}
                                        </a>
                                    </v-col> -->
                </v-row>
                <!-- {{ queue }} -->
                <v-slide-y-transition>
                  <v-row dense v-if="filters">
                    <v-col cols="12" v-if="['queue'].includes(module)">
                      <v-select
                        :disabled="isLoading || CurrentRole === 10"
                        multiple
                        :items="AllQueues"
                        :item-text="
                          (item) =>
                            CurrentRole === 10 ? item.number : `${item.name} ${item.qname ? `- ${item.qname}` : ''}`
                        "
                        item-value="qname"
                        required
                        filled
                        rounded
                        chips
                        deletable-chips
                        class="rounded-small"
                        dense
                        label="Colas"
                        prepend-inner-icon="mdi-database"
                        hide-details
                        color="info"
                        v-model="queue"
                      >
                        <template v-slot:prepend-item>
                          <v-list-item ripple @mousedown.prevent @click="toggle">
                            <v-list-item-action>
                              <v-icon :color="AllQueues.length > 0 ? 'indigo darken-4' : ''">
                                {{ icon }}
                              </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>
                                Seleccionar todo
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12" v-if="['queue'].includes(module)">
                      <v-select
                        :disabled="isLoading"
                        :items="[
                          { name: 'Dia', value: 'day' },
                          { name: 'Hora', value: 'hour' },
                        ]"
                        item-text="name"
                        item-value="value"
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Tiempo"
                        prepend-inner-icon="mdi-shape"
                        hide-details
                        color="info"
                        v-model="queueType"
                      >
                      </v-select>
                    </v-col>

                    <v-col cols="12" v-if="['cdr'].includes(module)">
                      <v-switch
                        v-model="numberOption"
                        :label="numberOption ? 'Búsqueda por número' : 'Búsqueda por extensión'"
                        hide-details
                      ></v-switch>
                    </v-col>

                    <v-col cols="12" v-if="['reportCalls', 'cdr'].includes(module) && !numberOption">
                      <v-autocomplete
                        multiple
                        :items="extensionItems"
                        item-text="extension"
                        item-value="extension"
                        required
                        :disabled="isLoading"
                        filled
                        rounded
                        chips
                        class="rounded-small"
                        dense
                        label="Extensiones"
                        prepend-inner-icon="mdi-headset"
                        hide-details
                        color="info"
                        v-model="extensionInput"
                      ></v-autocomplete>
                    </v-col>

                    <!-- FILTRO POR ESTADO -->
                    <v-col cols="12" v-if="['cdr'].includes(module) && !numberOption">
                      <v-autocomplete
                        :items="statusItems"
                        item-text="text"
                        item-value="value"
                        required
                        :disabled="isLoading"
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Estados"
                        hide-details
                        color="info"
                        v-model="statusCall"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" v-if="['cdr'].includes(module) && numberOption">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Número telefónico"
                        prepend-inner-icon="mdi-phone"
                        hide-details
                        color="info"
                        v-model="number"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" v-if="['reportCalls', 'cdr', 'agentsCallsInformation'].includes(module)">
                      <v-select
                        :items="callTypeItems"
                        item-text="text"
                        item-value="value"
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Tipo de llamada"
                        prepend-inner-icon="mdi-phone"
                        hide-details
                        color="info"
                        v-model="callType"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" v-if="['queue'].includes(module)">
                      <v-select
                        :items="callTypeQueueItems"
                        item-text="text"
                        item-value="value"
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Tipo de llamada"
                        prepend-inner-icon="mdi-phone"
                        hide-details
                        color="info"
                        v-model="callTypeQueue"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" v-if="['reportCalls'].includes(module) && callType == 1">
                      <v-select
                        :items="callTypeReportCallsItems"
                        item-text="text"
                        item-value="value"
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Clasificación de llamada"
                        prepend-inner-icon="mdi-tag"
                        hide-details
                        color="info"
                        v-model="callTypeReportCalls"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-slide-y-transition>
              </v-form>
            </v-card-text>
          </vuescroll>

          <v-divider></v-divider>

          <v-card-actions class="mx-2">
            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="openImportDialog"
                  v-bind="attrs"
                  v-on="on"
                  color="info"
                  small
                  rounded
                  fab
                  class="mr-2"
                >
                  <v-icon>
                    mdi-upload
                  </v-icon>
                </v-btn>
              </template>
              <span>Importar</span>
            </v-tooltip> -->

            <v-menu top>
              <template v-slot:activator="{ on, attrs }">
                <!-- <v-btn
                  text
                  rounded
                  color="success"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  Exportar

                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn> -->
                <!-- <v-tooltip bottom> -->
                <!-- <template v-slot:activator="{ on, attrs }"> -->
                <v-btn v-if="module !== 'chatReport'" color="success" v-bind="attrs" v-on="on" small rounded fab>
                  <v-icon> mdi-download </v-icon>
                </v-btn>
                <!-- </template> -->
                <!-- <span>Exportar</span>
        </v-tooltip> -->
              </template>

              <v-list>
                <v-list-item
                  @click="downloadCsv(false)"
                  v-if="['accumulatedIndicators', 'testReport'].includes(module)"
                >
                  <v-list-item-title> CSV </v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadCsv(false)" v-if="['appointments'].includes(module)">
                  <v-list-item-title> CSV </v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadCsv(false)" v-if="['reportCalls', 'cdr'].includes(module)">
                  <v-list-item-title> CSV </v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadCsv(false, 6)" v-if="['queue'].includes(module)">
                  <v-list-item-title> Time Out </v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadCsv(true)" v-if="['cdr'].includes(module)">
                  <v-list-item-title> Encuestas </v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadFiltered()" v-if="['cdr'].includes(module)">
                  <v-list-item-title> Filtrado </v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadCsv(false, 1)" v-if="['queue'].includes(module)">
                  <v-list-item-title> Ingresadas </v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadCsv(false, 2)" v-if="['queue'].includes(module)">
                  <v-list-item-title> Contestadas </v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadCsv(false, 3)" v-if="['queue'].includes(module)">
                  <v-list-item-title> Abandonadas </v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadCsv(false, 4)" v-if="['queue'].includes(module)">
                  <v-list-item-title> Transferidas </v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadCsv(false, 5)" v-if="['queue'].includes(module)">
                  <v-list-item-title> Intentos no atendidos </v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadCsv(false, 0)" v-if="['queue'].includes(module)">
                  <v-list-item-title> Todos </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }" v-if="!['testReport'].includes(module)">
              <v-btn
                text
                rounded
                class="mr-1"
                :color="hover ? 'error' : 'grey'"
                @click="CurrentRole === 10 ? sendformWithDefaultValues() : closedialog('cerrar')"
                >Cancelar</v-btn
              >
            </v-hover>

            <v-hover v-slot:default="{ hover }" v-if="!['testReport', 'appointments'].includes(module)">
              <v-btn
                rounded
                :loading="isLoading"
                :disabled="isLoading"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click="sendform"
                >Buscar</v-btn
              >
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>

    <!-- Import Dialog -->
    <import-dialog :module="module" :isOpenDialog="isOpenImport" @dialog:close="isOpenImport = false"></import-dialog>
  </v-row>
</template>

<script>
import vuescroll from "vuescroll";
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";
import CdrDownloadToCsv from "@/components/Utils/CdrDownloadCsv";
import ImportDialog from "@/components/ImportDialog/ImportDialog.vue";

const TODAY_DATE = moment().format("YYYY-MM-DD");

export default {
  name: "DateRangePickerDialog",

  props: {
    active: Boolean,
    id: {
      type: Number,
      required: false,
    },
    module: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
    },
    queues: {
      type: Array,
      required: false,
    },
    actualRol: {
      type: Number,
      required: false,
    },
  },

  components: {
    vuescroll,
    ImportDialog,
  },

  data() {
    return {
      TODAY_DATE: TODAY_DATE,
      searchByHour: false,
      isLoading: false,
      isOpenImport: false,
      dialog: false,
      dateRangeMenu: false,
      filters: true,
      numberOption: false,
      time: null,
      hour: false,
      queue: [],
      queueType: null,
      // customRequest: {},
      callTypeItems: [
        {
          text: "Todas",
          value: null,
        },
        {
          text: "Entrantes",
          value: 2,
        },
        {
          text: "Salientes",
          value: 1,
        },
      ],
      callTypeQueueItems: [
        {
          text: "Todas",
          value: false,
        },
        {
          text: "Externas",
          value: true,
        },
      ],
      callTypeReportCallsItems: [
        {
          text: "Todas",
          value: null,
        },
        {
          text: "Internas",
          value: 0,
        },
        {
          text: "Externas",
          value: 1,
        },
      ],
      statusItems: [
        {
          text: "Todas",
          value: null,
        },
        {
          text: "Contestadas",
          value: "ANSWERED",
        },
        {
          text: "No contestadas",
          value: "NO ANSWER",
        },
        {
          text: "Ocupado",
          value: "BUSY",
        },
        {
          text: "Fallido",
          value: "FAILED",
        },
      ],
      statusCall: "",
      callType: null,
      callTypeQueue: false,
      callTypeReportCalls: null,
      number: null,
      extensionInput: [],
      dates: [TODAY_DATE, TODAY_DATE],
    };
  },

  computed: {
    icon() {
      if (this.likesAllQueues) return "mdi-close-box";
      if (this.likesSomeQueues) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    likesAllQueues() {
      return this.queue.length === this.AllQueues.length;
    },

    CurrentRole() {
      return this.$store.getters["passport/GET_ROLE"];
    },

    ProfileInfo() {
      return this.$store.getters["passport/CURRENT_USER"];
    },

    likesSomeQueues() {
      return this.queue.length > 0 && !this.likesAllQueues;
    },

    AllQueues() {
      return this.queues ? this.queues : this.$store.getters["queue/GET_QUEUES"];
    },

    extensionItems() {
      return this.CurrentRole === 10 ? this.extensionItemsBySupervisor || [] : this.allExtension || [];
    },

    extension() {
      return this.CurrentRole === 10 ? this.extensionItemsBySupervisor || [] : this.extensionInput;
    },

    ...mapState({
      allExtension: (state) => state.callsInfo.allExtension,
      extensionItemsBySupervisor: (state) => state.passport.user.extensions,
    }),
  },

  watch: {
    AllQueues(val) {
      if (val.length && this.CurrentRole === 10) {
        this.queue = val.map((el) => el.number);
      }
    },
  },

  created() {
    if (
      this.module !== "agentsQueue" &&
      this.module !== "agentsCdr" &&
      this.module !== "agentsPauses" &&
      this.module !== "agentsCallsInformation" &&
      // this.module !== "accumulatedIndicators" &&
      this.module !== "productivityReport"
    ) {
      this.getSelectsData();
      this.getExtensionDate();
    }

    this.$store.dispatch("queue/GET_QUEUES", this.CurrentRole === 10);
  },

  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllQueues) {
          this.queue = [];
        } else {
          this.queue = this.AllQueues.map((item) => item.qname);
        }
      });
    },

    openImportDialog() {
      this.isOpenImport = true;
    },

    closedialog(value, parameters) {
      this.$emit("dialog:change", value, parameters);
      this.queue = [];
      this.callType = null;
      this.callTypeQueue = false;
      this.number = null;
      this.filters = false;
      this.dates = [];
      this.hour = null;
      this.searchByHour = false;
    },

    async getSelectsData() {
      if (this.module === "queue") {
        try {
          await this.$store.dispatch("queue/GET_QUEUES");
        } catch (error) {
          this.$snotify.error("No se pudo obtener listado de colas.", "¡Error!");
          // console.error(error);
        }
      }
      //  else {
      //     try {

      //         await this.$store.dispatch("callsInfo/SHOW_EXTENSION",this.dates);
      //     } catch (error) {
      //         this.$snotify.error(
      //             "No se pudo obtener listado de extensiones.",
      //             "¡Error!"
      //         );
      //         console.error(error);
      //     }
      // }
      this.isLoading = false;
    },
    async getExtensionDate() {
      try {
        this.isLoading = true;

        const response = await this.$store.dispatch("callsInfo/SHOW_EXTENSION", this.dates);

        // console.log("Extensiones obtenidas", response);
        if (response.status === 200) {
          this.isLoading = false;
        }
      } catch (error) {
        this.$snotify.error("No se pudo obtener listado de extensiones.", "¡Error!");
        this.isLoading = false;
        // console.error(error);
      }
    },

    async sendform() {
      const isValid = await this.$refs.obs.validate();
      if (!isValid) return;
      if (this.module === "chatReport") {
        this.$emit("dialog:change", {
          date: {
            start: this.dates[0],
            end: this.dates[1],
          },
        });
        return;
      }

      const accessToken = localStorage.getItem("token");

      this.isLoading = true;
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando",
      });

      if (this.dates[0] > this.dates[1]) {
        this.dates.reverse();
      }

      if (this.module === "queue") {
        try {
          if (this.searchByHour) {
            const value = this.dates[0];
            this.dates[1] = value;
            this.dates[0] = `${this.dates[0]}T${this.time}:00.000000Z`;
            this.dates[1] = `${this.dates[1]}T${this.time.substring(0, 2)}:59:00.000000Z`;
          } else {
            this.time = null;
          }

          const rq = {
            format: "P",
            value: {
              start: this.dates[0],
              end: this.dates[1],
              queue: this.queue,
            },
            hour: this.searchByHour,
            type: this.queueType,
            externals: this.callTypeQueue,
          };

          let response = await this.$store.dispatch("tail/GET_REPORT", rq);

          this.filters = false;
          this.isLoading = false;
          this.closedialog({
            date: {
              start: this.dates[0],
              end: this.dates[1],
              queue: this.queue,
              type: this.queueType,
              externals: this.callTypeQueue,
            },
            response,
          });
        } catch (error) {
          console.error(error);
        }
        this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
      } else if (this.module === "agentsPauses") {
        const request = {
          start: this.dates[0],
          end: this.dates[1],
        };
        this.closedialog("agentsPauses", request);
      } else if (this.module === "agentsCdr") {
        const request = {
          start: this.dates[0],
          end: this.dates[1],
        };
        this.closedialog("agentsCdr", request);
      } else if (this.module === "agentsCallsInformation") {
        const request = {
          start: this.dates[0],
          end: this.dates[1],
          call: this.callType,
        };
        this.closedialog("agentsCallsInformation", request);
      } else if (this.module === "agentsQueue") {
        // const request = {
        //   start: this.dates[0],
        //   end: this.dates[1],
        //   queue: this.queue,
        // };
      } else if (this.module === "accumulatedIndicators") {
        const request = {
          start_date: this.dates[0],
          end_date: this.dates[1],
        };
        this.closedialog("accumulatedIndicators", request);
      } else {
        let request = {
          start: this.dates[0],
          end: this.dates[1],
          extension: this.extension.join("-"),
          call: this.callType,
          status: this.statusCall,
          number: this.number,
        };

        // console.log("### request", request);

        if (this.callType == 1 && this.callTypeReportCalls != null) {
          request.externals = this.callTypeReportCalls;
        }
        // console.log("2", request);
        // this.customRequest = { ...request };

        if (this.module != "accumulatedIndicators") {
          this.$store.commit("layout/SET_OVERLAY", {
            value: true,
            title: "Cargando",
          });
          axios
            .get(`${process.env.VUE_APP_ROOTAPI}/${this.module}/custom`, {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
              params: {
                ...request,
              },
            })
            .then((res) => {
              this.filters = false;
              this.closedialog(res.data, request);
            })
            .catch(() => {
              // console.error(error);
              this.$snotify.error("Hubo un error en la consulta.", "Error");
            })
            .finally(() => {
              this.isLoading = false;
              this.$store.commit("layout/SET_OVERLAY", {
                value: false,
                title: "",
              });
            });
        }
      }
    },

    async sendformWithDefaultValues() {
      const accessToken = localStorage.getItem("token");
      if (this.module === "cdr" || this.module === "reportCalls") {
        let request = {
          start: this.dates[0],
          end: this.dates[1],
          extension: this.extensionItemsBySupervisor.join("-"),
          call: this.callType,
          status: this.statusCall,
          number: this.number,
        };
        this.$store.commit("layout/SET_OVERLAY", {
          value: true,
          title: "Cargando",
        });
        axios
          .get(`${process.env.VUE_APP_ROOTAPI}/${this.module}/custom`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            params: {
              ...request,
            },
          })
          .then((res) => {
            this.filters = false;
            this.closedialog(res.data, request);
          })
          .catch(() => {
            // console.error(error);
            this.$snotify.error("Hubo un error en la consulta.", "Error");
          })
          .finally(() => {
            this.isLoading = false;
            this.$store.commit("layout/SET_OVERLAY", {
              value: false,
              title: "",
            });
          });
      }
    },
    async downloadCsv(isAccountCode, queueType) {
      if (this.numberOption && !this.number) return;
      let payload = {
        start: this.dates[0],
        end: this.dates[1],
        call: this.callType,
        queue: this.queue,
        extension: this.extension.join("-") || null,
        number: this.numberOption ? this.number : null,
        accountcode: isAccountCode,
      };

      if (this.module === "accumulatedIndicators") {
        payload = {
          start_date: this.dates[0],
          end_date: this.dates[1],
        };
      }
      if (this.module === "testReport") {
        payload = {
          start: this.dates[0],
          end: this.dates[1],
          id: this.id,
        };
      }

      if (queueType !== 0) {
        payload.type = queueType;
      }

      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando",
      });
      try {
        await CdrDownloadToCsv(payload, this.module);
        this.closedialog("cerrar");
      } catch (err) {
        // console.log(err);
        this.$snotify.error("No se pudo descargar los registros seleccionados.", "¡Error!");
      }
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },
    async downloadFiltered() {
      const payload = {
        start_date: this.dates[0],
        end_date: this.dates[1],
      };
      await CdrDownloadToCsv(payload, "cdrFiltered");
    },
  },
};
</script>
